import { useNavigate } from "@solidjs/router";
import { login } from "../../services/loginService";
import { resendCode } from "../../services/registerService";
import { createSignal, Show } from "solid-js";
import { setUserEmail, setUserInterviews } from "../../stores/userStore";
import { fetchInterviews } from "../../services/GPTService";
import Loading from "../Loading";

export default function LoginForm() {
  const nav = useNavigate();
  const [email, setEmail] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [loginFail, setLoginFail] = createSignal(0);
  const [loading, setLoading] = createSignal(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await login(email(), password());

    if (res) {
      setUserEmail(email());
      setLoading(true);
      const prevInters = await fetchInterviews(email());
      setUserInterviews(prevInters.interviews);
      setLoading(false);
      nav("/home");
      return;
    } else if (res === null) {
      setLoginFail(1);
    } else {
      console.log("Incorrect username or password");
      setLoginFail(-1);
      return;
    }
  };

  return (
    <div id="login">
      <h2>Sign in to your account</h2>
      <form onSubmit={handleSubmit}>
        <div id="signup-form">
          <input
            class="login-input"
            placeholder="Email"
            onInput={(e) => setEmail(e.currentTarget.value)}
            required></input>
          <input
            class="login-input"
            type="password"
            placeholder="Password"
            onInput={(e) => setPassword(e.currentTarget.value)}
            required></input>
          <Show when={loginFail() === -1}>
            <p style="color: #878787; margin-top: -2px; margin-bottom: -2px;">
              Incorrect username or password
            </p>
          </Show>
          <Show when={loginFail() === 1}>
            <p style="color: #878787; margin-top: 0;">
              Your account has not been verified. Click{" "}
              <span
                style={{ "text-decoration": "underline", cursor: "pointer" }}
                onClick={() => {
                  resendCode(email());
                  nav("/verify", { state: { email: email() } });
                }}>
                here{" "}
              </span>
              to receive a verification email
            </p>
          </Show>
          <button class="button1" style="width: 100px" type="submit">
            Sign In
          </button>
        </div>
      </form>
      <p class="subtext-compact">
        Don't have an account?{" "}
        <span
          style={{ "text-decoration": "underline", cursor: "pointer" }}
          onClick={() => nav("/register")}>
          Sign up
        </span>
      </p>
      <Loading show={loading()} />
    </div>
  );
}
